<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >商务&销售管理</el-breadcrumb-item
        >
        <template v-if="type == 'rServiceRecordList'">
          <el-breadcrumb-item :to="{ path: '/resourceIndex/serviceIndex' }"
            >客户服务管理</el-breadcrumb-item
          >
          <el-breadcrumb-item :to="{ path: '/resourceIndex/rServiceDetail' }"
            >客户详情</el-breadcrumb-item
          >
          <el-breadcrumb-item
            :to="{ path: '/resourceIndex/rServiceRecordList' }"
            >客户订单记录</el-breadcrumb-item
          >
        </template>
        <el-breadcrumb-item v-else :to="{ path: '/comSalesIndex/' + type }">{{
          type == "cSellOrderList"
            ? "销售业务管理"
            : type == "cBusinessOrderList"
            ? "销售业务订单审核"
            : type == "cClientOrderList"
            ? "客户订单管理"
            : type == "cRetailOrderList"
            ? "零售订单管理"
            : ""
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>订单详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <div class="content_wrap flex-rowl">
        <div class="tip_wrap">
          <div class="item">
            <h1>订单号：</h1>
            <p>{{ dataItem.orderno }}</p>
          </div>
          <div class="item">
            <h1>创建时间：</h1>
            <p>{{ dataItem.createdate | formatDate }}</p>
          </div>
          <div class="item">
            <h1>销售专员姓名：</h1>
            <p>{{ dataItem.saler }}</p>
          </div>
          <div class="item shop_item">
            <div
              class="block"
              v-for="(item, index) in dataItem.goods"
              :key="index"
            >
              <h1>
                商品名称：<span>{{ item.commodityname }}</span>
              </h1>
              <h1>
                商品ID：<span>{{ item.id }}</span>
              </h1>
              <h1>
                商品SKU：<span>{{ item.sku }}</span>
              </h1>
              <h1 v-if="item.cbprice">
                成本参考价：<span>¥ {{ item.cbprice | formatPrice }}/件</span>
              </h1>
              <h1 v-if="item.price">
                基础零售价：<span>¥ {{ item.price | formatPrice }}/件</span>
              </h1>
              <h1 v-if="item.pfprice">
                批发参考价：<span>¥ {{ item.pfprice | formatPrice }}/件</span>
              </h1>
              <h1 v-if="item.groupprice">
                基础批发价：<span>¥ {{ item.groupprice }}/件</span>
              </h1>
              <h1>
                <p v-for="(label, labelIndex) in item.attr" :key="labelIndex">
                  <span>{{ label }}</span
                  ><span>：{{ item.attrPrice }}/件</span>
                </p>
              </h1>
              <h1>
                商品数量：<span>{{ item.num }}</span>
              </h1>
              <h1>
                价格小计：<span>{{ item.newPrice | formatPrice }}</span>
              </h1>
              <h1>商品类型：<span>主商品</span></h1>
            </div>
            <div
              class="block"
              v-for="(item, index) in dataItem.goods_pei"
              :key="index"
            >
              <h1>
                商品名称：<span>{{ item.commodityname }}</span>
              </h1>
              <h1>
                商品ID：<span>{{ item.id }}</span>
              </h1>
              <h1>
                商品SKU：<span>{{ item.sku }}</span>
              </h1>
              <h1 v-if="item.cbprice">
                成本参考价：<span>¥ {{ item.cbprice }}/件</span>
              </h1>
              <h1 v-if="item.price">
                基础零售价：<span>¥ {{ item.price }}/件</span>
              </h1>
              <h1 v-if="item.pfprice">
                批发参考价：<span>¥ {{ item.pfprice }}/件</span>
              </h1>
              <h1 v-if="item.groupprice">
                基础批发价：<span>¥ {{ item.groupprice }}/件</span>
              </h1>
              <!-- <h1>
                <p v-for="(label, labelIndex) in item.attr" :key="labelIndex">
                  <span>{{ label }}</span
                  ><span>：{{ item.attrPrice }}/件</span>
                </p>
              </h1> -->
              <h1>
                商品数量：<span>{{ item.num }}</span>
              </h1>
              <h1>
                价格小计：<span>{{ item.newPrice }}</span>
              </h1>
              <h1>商品类型：<span>配件</span></h1>
            </div>
          </div>
        </div>
        <div class="tip_wrap">
          <div class="item">
            <h1>购买人：</h1>
            <p>{{ dataItem.qy_truename }}</p>
          </div>
          <div class="item">
            <h1>购买人联系方式：</h1>
            <p>{{ dataItem.qy_linktype }}</p>
          </div>
          <div class="item">
            <h1>客户企业：</h1>
            <p>{{ dataItem.qw_appidstr }}</p>
          </div>
          <div class="item">
            <h1>客户职务：</h1>
            <p>{{ dataItem.qw_job }}</p>
          </div>
          <div class="item">
            <h1>收件人：</h1>
            <p>{{ dataItem.truename }}</p>
          </div>
          <div class="item">
            <h1>收件人联系方式：</h1>
            <p>{{ dataItem.cellphone }}</p>
          </div>
          <div class="item">
            <h1>测试省/直辖市</h1>
            <p>{{ dataItem.addr }}</p>
          </div>
          <div class="pay_item item">
            <h1>支付方式：{{ dataItem.paymsg }}</h1>
            <p>银行账户名：{{ dataItem.paymsg_truename }}</p>
            <p>开户行：{{ dataItem.paymsg_bank }}</p>
            <p>银行账号：{{ dataItem.paymsg_account }}</p>
          </div>
          <div class="item">
            <h1>备注信息：</h1>
            <p>
              {{ dataItem.saler_note ? dataItem.saler_note : "无备注信息" }}
            </p>
          </div>
        </div>
        <div class="tip_wrap">
          <div class="item">
            <h1>订单价格核算：</h1>
            <p v-if="dataItem.price_original">
              ￥{{ dataItem.price_original | formatPrice }}
            </p>
          </div>
          <div class="item">
            <h1>物流费用：</h1>
            <p>￥{{ dataItem.runfee ? dataItem.runfee : 0 }}</p>
          </div>
          <div class="item">
            <h1>实际订单价格：</h1>
            <p v-if="dataItem.price">￥{{ dataItem.price | formatPrice }}</p>
          </div>
          <!-- <div class="item">
            <h1>差额：</h1>
            <p>￥{{ dataItem.runfee }}</p>
          </div> -->

          <div class="item">
            <h1>已付金额：</h1>
            <p v-if="dataItem.paynum">
              <span>¥</span>
              {{ dataItem.paynum | formatPrice }}
            </p>
            <p v-else>￥ 0.00</p>
          </div>
          <div class="item">
            <h1>差额：</h1>
            <p v-if="dataItem.diffrentprice">
              <span>¥</span>
              {{ dataItem.diffrentprice | formatPrice }}
            </p>
            <p v-else>￥ 0.00</p>
          </div>
          <div class="item">
            <h1>待结清金额：</h1>
            <p v-if="dataItem.waitMoney">
              <span>¥</span>
              {{ dataItem.waitMoney | formatPrice }}
            </p>
            <p v-else>￥ 0.00</p>
          </div>

          <div class="item">
            <h1>订单审核状态：</h1>
            <p class="red">
              {{
                dataItem.ischeck == 0
                  ? "待审核"
                  : dataItem.ischeck == 1
                  ? "审核通过"
                  : dataItem.ischeck == 2
                  ? "审核不通过"
                  : ""
              }}
            </p>
          </div>
          <div class="item">
            <h1>退费申请状态：</h1>
            <p class="red">
              {{
                dataItem.isreturn === true
                  ? "是"
                  : dataItem.isreturn === false
                  ? "否"
                  : "无"
              }}
            </p>
          </div>
          <div class="item">
            <h1>退费状态：</h1>
            <p class="red">
              {{ dataItem.returnstate }}
            </p>
          </div>
          <div class="item">
            <h1>订单情况：</h1>
            <p class="red">
              {{
                dataItem.ordertalk == 1
                  ? "进行中"
                  : dataItem.ordertalk == 2
                  ? "已完成"
                  : dataItem.ordertalk == 3
                  ? "已关闭"
                  : "无"
              }}
            </p>
          </div>
          <div class="item" v-if="type =='cRetailOrderList' || type == 'cClientOrderList'">
            <h1>发货情况：</h1>
            <p class="red">{{ dataItem.orderstate }}</p>
          </div>
        </div>
        <div class="tip_wrap" v-if="type =='cSellOrderList' || type == 'cBusinessOrderList'">
          <div class="item">
            <h1>发货统计：</h1>
            <p class="red"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl" v-if="isShow">
      <!-- 业务订单审核 -->
      <template v-if="type == 'cBusinessOrderList'">
        <div class="btn" :class="{'disabled': dataItem.ischeck != 1}" @click="handleGo('cPaymentList','sk')">订单收款管理</div>
        <div class="btn" @click="handleGo('cOrderCheck')">订单审核管理</div>
        <div class="btn" @click="handleToast">订单关闭</div>
      </template>
      <!-- 销售业务管理 -->
      <template v-else-if="type == 'cSellOrderList'">
        <div class="btn" :class="{'disabled': dataItem.ischeck != 1}" @click="handleGo('cPaymentList','shdj')">收款登记</div>
        <div class="btn" @click="handleToast">发货管理</div>
      </template>
      <template v-else>
        <div class="btn" @click="handleToast">收款登记</div>
        <div class="btn">发货计划</div>
        <div class="btn" @click="handleToast">退款申请</div>
      </template>
      
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>

<script>
import { encryptstringview, encryptstringadd } from "../../../api/api";
import { getOrderListDetail } from "../../../api/shop";
import { calculator } from "../../../utils/decimal";
import { mapState } from "vuex";
export default {
  name: "cOrderDetail",
  data() {
    return {
      isShow: false,
      loading: false,
      qyid: "",
      dataItem: "",
      type: "",
      orderId: '',
      orderOpenid: ''
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) "0.00";
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    if (USERINFO.qy) {
      this.qyid = USERINFO.qy.qyid;
    } else {
      this.qyid = 0;
    }

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, openid, type } = JSON.parse(res.jsondata);
        this.type = type;
        this.orderId = id
        this.orderOpenid = openid
        this.getOrderListDetail(id, openid);
      } else {
        this.$router.back();
      }
    },
    // 订单列表
    getOrderListDetail(id, openid) {
      let params = {
        openid: openid,
        orderid: id,
      };
      this.loading = true;
      getOrderListDetail(params).then((res) => {
        let newObj = res[0];
        let newGoods =
          newObj.goodsjson != "" && newObj.goodsjson
            ? JSON.parse(newObj.goodsjson)
            : "";
        if (newObj.goods.length > 0) {
          newObj.goods.forEach((v1, index) => {
            v1.attr = v1.attr != "" ? JSON.parse(v1.attr) : v1.attr;
            if (newGoods != "") {
              v1.orderGood = newGoods[index];
              // 单件商品总价 (零售价 +/- 标签价) * 数量  后续加入折扣价针对于第一个商品
              let attrPrice =
                v1.orderGood.attrnumtype == "不变"
                  ? 0
                  : v1.orderGood.attrnumtype == "减少"
                  ? "-" + v1.orderGood.attrnum
                  : v1.orderGood.attrnum;

              v1.attrPrice =
                v1.orderGood.attrnumtype == "不变"
                  ? "¥" + 0
                  : v1.orderGood.attrnumtype == "减少"
                  ? "- ¥" + v1.orderGood.attrnum
                  : "+ ¥" + v1.orderGood.attrnum;
              v1.newPrice = calculator(calculator(v1.price).add(attrPrice))
                .multiply(v1.num)
                .toNumber();
            } else {
              v1.newPrice = calculator(v1.price).multiply(v1.num).toNumber();
            }
          });
        }
        if (newObj.goods_pei.length > 0) {
          newObj.goods_pei.forEach((v1) => {
            v1.newPrice = calculator(v1.price).multiply(v1.num).toNumber();
          });
        }
        // 待结清金额 = price - paynum
        newObj.waitMoney = calculator(newObj.price)
          .subtract(newObj.paynum ? newObj.paynum : 0)
          .toNumber();
        this.dataItem = newObj;
        this.loading = false;
        this.isShow = true;
      });
    },

    handleReturn() {
      this.$router.back();
    },

    handleToast() {
      this.$message.warning("即将开放");
    },

    // 计算商品差价
    shopPriceDifference(price, price1) {
      return calculator(price1).subtract(price).toNumber();
    },

    handleGo(type, state) {
      let {dataItem, orderId, orderOpenid} = this
      console.log(orderId,'===');
      if(type == 'cPaymentList' && dataItem.ischeck != 1) {
        // this.$message.warning("即将开放");
      }else {
        this.encryptstringadd(type, { orderno: dataItem.orderno, orderId, orderOpenid, state });
      }
      
      // this.$router.push(`/comSalesIndex/cOrderDetail/${id}/${openid}/${this.type}`);
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: '',
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .form_container {
    align-items: flex-start;
    flex-flow: wrap;
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex-shrink: 0;
        width: calc(70% / 3);
        &:first-child {
          flex-shrink: 0;
          width: 30%;
        }
        .item {
          margin-bottom: 15px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
            white-space: nowrap;
          }
          &.shop_item {
            font-size: 14px;
            h1 {
              font-size: 16px;
              span {
                color: #6e6e6e;
                font-size: 14px;
              }
            }
            .block {
              margin-bottom: 20px;
            }
          }
          p {
            &.red {
              color: red;
            }
          }
          &.pay_item {
            p {
              margin-bottom: 5px;
            }
          }
        }
      }
    }
  }
  .form_footer {
    .btn {
      &:nth-child(2n) {
        margin: 0 30px;
      }
      &.disabled {
         background: #a6a6a6;
      }
    }
  }
}
</style>